<template>
  <v-dialog
    v-model="value"
    persistent
    width="500"
  >
    <v-card>
      <v-card-text>
        <span class="title">{{ text }}</span>
      </v-card-text>
      <v-card-actions>
        <v-btn
          small
          class="primary"
          @click="$emit('confirm')"
        >
          Ok
        </v-btn>
        <v-btn
          small
          @click="$emit('cancel')"
        >
          Отмена
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["value", "text"],
};
</script>
